import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/services/general.service';
import { EmailClientService } from 'src/app/services/integrations/email/email-client.service';
import { EmailService } from 'src/app/services/integrations/email/email.service';
import { LeadsCustomersService } from 'src/app/services/settings-services/leads-customers.service';
import { AppState } from 'src/app/store/app.state';
import { Office365OuthSettings } from 'src/environments/environment';
import EmailAnimations from 'src/app/shared/components/integration/email/animations';
import EmailAttachmentHelper from 'src/app/shared/components/integration/email/email-attachment';
import EmailDeals from 'src/app/shared/components/integration/email/email-deal';
import EmailHelper from 'src/app/shared/components/integration/email/email-helper';
import { EmailNotificationService } from 'src/app/services/settings-services/email-notification.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import $ from 'jquery'


@Component({
  selector: 'app-send-invoice',
  templateUrl: './send-invoice.component.html',
  styleUrls: ['./send-invoice.component.css']
})

export class SendInvoiceComponent implements OnInit, OnDestroy, AfterViewInit {
  /** */
  @Input() component_id: any;
  @Input() companyName:string;
  @Input() invoiceId:any;
  @Input() invoiceDetails:any;
  @Input() fileDetails:any;
  @Input() sendInvoice: any;

  html_ids: any = {};
  modal_is_opened: boolean = false;


  /** */
  userId: number;
  orgId: number;
  orgName: string;
  user_data: any;
  name:string;

  /** FOR QUOTE/INVOICE SENDING */
  sales_item: any;
  has_sales_item: boolean = false;

  formMessage = {
    class: '',
    message: '',
  }

  response: object;
  current_uri: string;
  inputCc = '';

  mailSending: boolean = false;

  /** FOR EMAIL VIEWING */
  currentlyOpenedMail: any = {};
  currentlyOpenedMailExists: boolean = false;
  context_name: string;

  mailIsReply: boolean;
  mailSubject: string;
  mailBody: string;

  /** EMAIL HELPERS*/
  emailHelper;
  attachmentHelper;
  emailAnimations;
  emailDeals;
  email: any;
  attachmentResponse: any;
  selectedClientsDetails: any;
  selectedClientName: any;
  selectedInvoice: any;
  clientName: string;
  recipient: any;
  closemodal: any;
  closeBtn: any;

  constructor(
    private generalService: GeneralService,
    private emailService: EmailService,
    private emailClientService: EmailClientService,
    private leadCustomerService: LeadsCustomersService,
    private store: Store<AppState>,
    private toast: ToastrService,
    private notificationService: EmailNotificationService,
    private genService: GeneralService,
    private invoiceSer: InvoiceService,
  ) {
    
    this.emailHelper = EmailHelper;
    this.attachmentHelper = new EmailAttachmentHelper(emailService, emailService.getAttachmentUrl(), toast);

    //
    this.store.select('userInfo').subscribe(info => {
      this.email = info.user.email
      if (Object.keys(info).length) {
        this.userId = info.user.id;
        this.orgId = info.organization.id;
        this.orgName = info.organization.name.replace(/(\s)/gi, '');
        this.email = info.user.email
      }
    })
  }

  ngOnInit() {
    this.emailService.sales_item.subscribe(data => {
      if (!this.generalService.checkIfObjectIsEmpty(data)) {
        this.resetForm();
        const item_type = data.type.toLowerCase() === 'quote' ? 'quotation' : 'invoice';
        this.has_sales_item = true;
        this.sales_item = {
          type: item_type,
          id: data.payload[item_type].id,
          payload: data.payload
        }

        this.emailHelper.inputTo = data.payload.client.email;
        
        document.getElementById('header-nav-new-mail-btn').click();
      }
    });

    this.emailAnimations = new EmailAnimations(this.component_id);

    this.html_ids = {
      email_area: `email-area-${this.component_id}`,
      input_cc: `input-cc-${this.component_id}`,
      input_cc_list: `input-cc-list-${this.component_id}`,
      input_bcc: `input-bcc-${this.component_id}`,
      input_bcc_list: `input-bcc-list-${this.component_id}`,
      file_upload_btn: `fileUploadBtn-${this.component_id}`,
      email_deal: `email-deal-${this.component_id}`,
    }

    this.emailService.selectedEmail.subscribe(email => {

      if (!this.generalService.checkIfObjectIsEmpty(email)) {
        this.mailIsReply = true;
        this.currentlyOpenedMail = this.emailHelper.processCurrentlyOpenedMail(email, this.user_data.serviceKey);

        this.emailHelper.processReplySelection('selectedCcRecipients', email.body.cc);
        this.emailHelper.processReplySelection('selectedBccRecipients', email.body.bcc);

        this.mailSubject = this.currentlyOpenedMail.subject;
        this.emailHelper.inputTo = this.currentlyOpenedMail.from;
        this.mailBody = this.currentlyOpenedMail.body;

        this.currentlyOpenedMailExists = true;
      }
    }, error => {
    });

    this.emailAnimations.loadFormElements();
  }

  ngAfterViewInit(): void {
    this.emailAnimations.loadFormElements();
  }

  ngOnDestroy() {
    this.emailService.context_primary_email_address.next("")
  }

  setLookUpGroup(group: string) {
    this.emailClientService.recipient_group.next(group);
  }
  removeSalesItem() {

  }






  /** */
  checkIfFieldIsEmpty() {

    const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(!this.recipient){
      this.displayFormMessage(0, `Recipient cannot be empty`);
      return true;
    }
    if (this.recipient && !emailPattern.test(this.recipient.trim())) {
      this.displayFormMessage(0, `Enter a valid recipient`);
      return true;
    }

    if (this.mailSubject === undefined || this.mailSubject.length <= 0) {
      this.displayFormMessage(0, `Subject cannot be empty`);
      return true;
    }

    if (!this.mailBody) {
      this.displayFormMessage(0, `Mail body cannot be empty`);
      return true;
    }

    return false;
  }

  validateCopiedEmails() {
    const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const emails = [
      ...this.emailHelper.reduceSelectedRecipients('selectedCcRecipients').split(','),
      ...this.emailHelper.reduceSelectedRecipients('selectedBccRecipients').split(',')
    ];

    for (let i in emails) {
      const email = emails[i].trim();
      if (!email) continue;
      if (!emailPattern.test(email)) {
        this.displayFormMessage(0, `Invalid email: ${email}`);
        return false;
      }
    }
    return true;
  }

  discard() {
    this.generalService.sweetAlertContinue('Discard mail')
      .then((response: any) => {
        if (response.value) {
          this.emailHelper.clearSelectedRecipients()
          this.emailHelper.clearTemporarySelections()
          this.emailHelper.inputTo = this.context_name == 'dashboard' ? '' : this.emailHelper.inputTo,
          this.mailBody = '';
          this.mailIsReply = false;
          this.recipient= [],
          this.mailSubject = '';
          this.inputCc="";
          this.attachmentHelper.selectedAttachments = {};
          this.resetForm()
          
        };
      })
  }

  resetForm() {
    this.emailHelper.clearSelectedRecipients()
          this.emailHelper.clearTemporarySelections()
          this.emailHelper.inputTo = '';
          this.mailBody = '';
          this.mailIsReply = false;
          this.recipient= [],
          this.mailSubject = '';
          this.inputCc="";
          this.attachmentHelper.selectedAttachments = {};
  }



  processMailBody(body) {
    const pattern1 = /\r\n/;
    const pattern2 = /\n/;
    if (pattern1.test(body)) {
      return body.replace(/\r\n/g, '<br/>');
    } else if (pattern2.test(body)) {
      return body.replace(/\n/g, '<br/>');
    } else {
      return body;
    }
  }

  async sendMail() {
    const fileDetails:any = await this.sendInvoice.call(this);
    if (this.checkIfFieldIsEmpty()) return;

    if (!this.validateCopiedEmails()) return;

    this.displayFormMessage(3, `Sending Mail`);


    const mailBody = this.processMailBody(this.mailBody);

    const message = {
      bcc: this.emailHelper.reduceSelectedRecipients('selectedBccRecipients'),
      message: mailBody,//+ `<br><br><br> ${attachments.text || ''}`,
      cc: this.emailHelper.reduceSelectedRecipients('selectedCcRecipients'),
      subject: this.mailSubject,
      from: this.companyName,
      replyTo:this.email,
      recipient: [this.recipient],
      type: this.mailIsReply ? 'reply' : undefined,
      file:[{name:fileDetails.name, type:fileDetails.type, encoded:fileDetails.encoded, size:fileDetails.size}]
    }

    this.toggleMailSendingLoader();

    this.notificationService.sendInvoice(message).subscribe((response: any) => {
      this.processEmailSendResponse(response);
      this.clearContent();
    }, error => {
      this.displayFormMessage(0, `Error: Sending failed.`);
      this.toggleMailSendingLoader();
    })

  }

  clearContent() {
    this.emailHelper.clearSelectedRecipients()
    this.emailHelper.clearTemporarySelections()
    this.emailHelper.inputTo = this.context_name == 'dashboard' ? '' : this.emailHelper.inputTo,
    this.mailBody = '';
    this.mailIsReply = false;
    this.recipient= [],
    this.mailSubject = '';
    this.inputCc="";
    this.attachmentHelper.selectedAttachments = {};
  }


  /** process server response from an email send */
  processEmailSendResponse(response) {
    this.toggleMailSendingLoader();
    if (response === null) {
      this.displayFormMessage(1, `Message Sent.`);
      setTimeout(() => {
        document.getElementById('close-send-invoice-form-btn').click();
      }, 1000)
      this.resetForm();
    } else {
      this.displayFormMessage(0, `Error: Sending failed.`);
    }
  }


  openFileUploadDialog() {
    const fileUploadBtn = document.getElementById(this.html_ids.file_upload_btn);
    fileUploadBtn.click();
  };

  toggleMailSendingLoader() {
    this.mailSending = this.mailSending;
  }

  flattenEmailRecipients(recipients) {
    const recipientMails = recipients.map(recipient => recipient.address);
    return recipientMails.join();
  }

  determineAlertClass(code) {
    switch (code) {
      case 0: // error
        return `alert alert-danger`;
      case 1: // success
        return `alert alert-success`;
      default:
        return `alert alert-info`;
    }
  }

  displayFormMessage(code, message) {
    this.formMessage.class = this.determineAlertClass(code);
    this.formMessage.message = message;
    setTimeout(() => {
      this.formMessage = {
        class: '',
        message: ''
      }
    }, 2500);
  }
}
